$(function() {
    // プラン変更ボタン制御(連打抑止)
    $('#area-mypage-user-update-kind-check button').on('click',function() {
        var formObj = $(this).parents('form');
        if($(this).attr('name') == "mode")
            formObj.append('<input type="hidden" name="mode" value="'+$(this).attr('value')+'" />');
        formObj.find('button').prop('disabled',true);
        formObj.submit();
    });

    // 参加予定のイベント一覧へ
    $('.js-my-entriedEventLink').on('click', function (e) {
        e.preventDefault();
        window.sessionStorage.setItem('event_entried', 1);
        window.location.href = $(this).attr('href');
    });


    // 退会するボタンの無効制御
    $('#sign-delete').change(function() {
        let result = $(this).prop('checked');
        let btnObj = $('#unsubscribe-btn');
        if(result)
          btnObj.prop('disabled', false);
        else
          btnObj.prop('disabled', true);
    });

});

